// Draft, snapshot, events, preview, estimate and actions live under separate branches on
// purpose: invalidating one must never refetch the others (a replay refetch would race the stream).
export const agentRunKeys = {
	all: ['agent'],
	draft: () => ['agent', 'draft'],
	detail: (runId) => ['agent', 'run', runId],
	events: (runId) => ['agent', 'events', runId],
	preview: (runId) => ['agent', 'preview', runId],
	estimate: (runId) => ['agent', 'estimate', runId],
	actions: (runId) => ['agent', 'actions', runId],
};

export const agentRunMutationKeys = {
	createDraft: ['agent', 'draft', 'create'],
	discardDraft: ['agent', 'draft', 'discard'],
	message: ['agent', 'message'],
	mandate: ['agent', 'mandate'],
	confirm: ['agent', 'confirm'],
	stop: ['agent', 'stop'],
	save: ['agent', 'save'],
	popup: ['agent', 'popup'],
};
